/**
 * Internal dependencies
 */
import './colors';
import './connect';
import './media-selector'; // Export support names.

export { SUPPORT_NAME as SUPPORT_MEDIA_SELECTOR } from './media-selector';
export { SUPPORT_NAME as SUPPORT_SIZES } from './sizes';
export { SUPPORT_NAME as SUPPORT_CONNECT_PROVIDER } from './connect/provider';
export { SUPPORT_NAME as SUPPORT_CONNECT_CONSUMER } from './connect/consumer';
//# sourceMappingURL=index.js.map